import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalConverterHeaderFooterMargins} from "./PortalConverterHeaderFooterMargins";

export enum HeaderFooterAlignment {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right",
}

export class PortalConverterHeaderFooter implements Parameter {
	public plain?: boolean;
	public fontSize?: number;
	public fontFamily?: string;
	public alignment?: HeaderFooterAlignment;
	public color?: string;
	public content?: string;
	public margins?: PortalConverterHeaderFooterMargins;

	constructor(data: any) {
		this.plain = FunctionHelper.exists(data?.plain) ? data.plain : true;
		this.fontSize = FunctionHelper.exists(data?.fontSize) ? data.fontSize : 10;
		this.fontFamily = FunctionHelper.exists(data?.fontFamily) ? data.fontFamily : "";
		this.alignment = FunctionHelper.exists(data?.alignment) ? data.alignment : HeaderFooterAlignment.LEFT;
		this.color = FunctionHelper.exists(data?.color) ? data.color : "#000000";
		this.content = FunctionHelper.exists(data?.content) ? data.content : "";
		this.margins = PortalConverterHeaderFooterMargins.fromJson(data?.margins);
	}

	public static getPlainDefault(): boolean {
		return true;
	}

	public static getFontSizeDefault(): number {
		return 10;
	}

	public static getFontSizeMin(): number {
		return 0;
	}

	public static getFontSizeMax(): number {
		return 1296;
	}

	public static getFontFamilyDefault(): string {
		return "";
	}

	public static getAlignmentDefault(): HeaderFooterAlignment {
		return HeaderFooterAlignment.LEFT;
	}

	public static getColorDefault(): string {
		return "#000000";
	}

	public static getContentDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalConverterHeaderFooter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalConverterHeaderFooter(data);
	}

	public toJson(): any {
		return {
			"plain": this.plain,
			"fontSize": this.fontSize,
			"fontFamily": this.fontFamily,
			"alignment": this.alignment,
			"color": this.color,
			"content": this.content,
			"margins": this.margins?.toJson()
		};
	}

	public clone(): PortalConverterHeaderFooter {
		return PortalConverterHeaderFooter.fromJson(this.toJson());
	}
}